import { Injectable } from "@angular/core";

@Injectable()
export class ApiConnectService {
  // backend server URL:
 public baseApiUrl = "/backend";
  //public baseApiUrl = 'http://192.168.140.95:8081';
  // public baseApiUrl = 'http://localhost/backend';             // Local dev server
  // public baseApiUrl = 'http://52.210.165.200/backend';     // EnCata production server
  // public baseApiUrl = 'http://int.encata.net/backend';     // EnCata production server domain

  // Build x.x.xx-rc.1
  public buildVersion = "App v1.4.38"; // Release Candidate (rc); Beta (b);
  public buildServerVersion = "Server v0.2.8";

  // External services URLs
  public planfixBaseUrl = "https://cuby.planfix.com";

  // routes:
  public logIn = this.baseApiUrl + "/auth/user/";
  public logOut = this.baseApiUrl + "/logout";
  public recordLogoutTime = this.baseApiUrl + "/common/time/logout/";
  public getListStandartsReport = this.baseApiUrl + "/common/user/";
  // public getNotifications = this.baseApiUrl + '/common/notifications/last';
  public getNotifications =
    this.baseApiUrl + "/common/notifications/standards";
  public getUserById = this.baseApiUrl + "/common/user/";
  public getUserByIdNoSalary = this.baseApiUrl + "/common/user/without_salary/"; 
  public getCloth = this.baseApiUrl + "/common/head/users/clothes/";// +ID
  public getClothPF = this.baseApiUrl + "/common/head/users/extradite/clothes/";// +ID
  public clothingCatalog = this.baseApiUrl + "/admin/clothing/catalog";
  public clothingMarkers = this.baseApiUrl + "/admin/clothing/markers";
  public clothingConfiguredMarkers = this.baseApiUrl + "/admin/clothing/markers/configured";
  public clothingNorms = this.baseApiUrl + "/admin/clothing/norms";
  public clothingNormsByMarker = this.baseApiUrl + "/admin/clothing/norms/by-marker";
  public clothingSettings = this.baseApiUrl + "/admin/clothing/settings";
  public clothingPersonalNorms = this.baseApiUrl + "/admin/clothing/personal-norms";
  public clothingPersonalNormsByUser = this.baseApiUrl + "/admin/clothing/personal-norms/by-user";
  public clothingStorekeeperAssignments = this.baseApiUrl + "/admin/clothing/storekeeper-assignments";
  public clothingIssuedStats = this.baseApiUrl + "/admin/clothing/stats/issued";
  public employeeClothingOverview = this.baseApiUrl + "/common/employee/clothing/overview";
  public employeeClothingEntitlements = this.baseApiUrl + "/common/employee/clothing/entitlements";
  public employeeClothingRequests = this.baseApiUrl + "/common/employee/clothing/requests";
  public employeeClothingLossCases = this.baseApiUrl + "/common/employee/clothing/loss-cases";
  public headClothingPositions = this.baseApiUrl + "/common/head/clothing/employees/";
  public headClothingPendingLossCases = this.baseApiUrl + "/common/head/clothing/loss-cases/pending";
  public headClothingLossCaseActions = this.baseApiUrl + "/common/head/clothing/loss-cases/";
  public ceoClothingPendingLossCases = this.baseApiUrl + "/common/ceo/clothing/loss-cases/pending";
  public ceoClothingLossCaseActions = this.baseApiUrl + "/common/ceo/clothing/loss-cases/";
  public headClothingPositionActions = this.baseApiUrl + "/common/head/clothing/positions/";
  public storekeeperClothingOverview = this.baseApiUrl + "/common/storekeeper/clothing/employees/";
  public storekeeperClothingEntitlements = this.baseApiUrl + "/common/storekeeper/clothing/employees/";
  public storekeeperClothingDirectIssue = this.baseApiUrl + "/common/storekeeper/clothing/employees/";
  public storekeeperClothingEmployees = this.baseApiUrl + "/common/storekeeper/clothing/employees";
  public storekeeperClothingRequests = this.baseApiUrl + "/common/storekeeper/clothing/requests";
  public biometrics = this.baseApiUrl + "/common/head/users/parameters/" ;
  public getAllUsers = this.baseApiUrl + "/common/users/";
  public lastVector = this.baseApiUrl + "/common/head/users/vector/current_last/";
  public lastVectorListUsers = this.baseApiUrl + "/common/head/users/vectors";
  public fullVector = this.baseApiUrl + "/common/head/users/vector/group/";
  public getShift = this.baseApiUrl + "/common/head/user/current/schedule/";
  public getShiftget = this.baseApiUrl + "/common/user/current/schedule/";
  public pullShift = this.baseApiUrl + "/common/head/user/update/schedule";
  public fullVectorAll = this.baseApiUrl + "/common/head/users/vector/groups/"
  public getMyGroups = this.baseApiUrl + "/common/user/"; // {id}/groups';
  public getAllSchedules = this.baseApiUrl + "/common/head/schedules/";
  public postiruem = this.baseApiUrl + "/common/head/user/payroll_method/";
  public postiruemOver = this.baseApiUrl + "/common/head/user/overtime/";
  public outsorce = this.baseApiUrl + "/common/head/user/outsourcer/";
  public getAllGroups = this.baseApiUrl + "/common/head/groups/";
  public getAllGroupsForStandartList = this.baseApiUrl + "/common/head/staffed/groups/";
  public getAllGroupsForStandartListMap = this.baseApiUrl + "/common/specgroup/group/";
  public getAllGroupsHeadAll = this.baseApiUrl + "/common/group/heading/all";
  public getAllGroupsHead = this.baseApiUrl + "/common/groups/with/head";
  public getAllGroupsHeadPlanfix =
    this.baseApiUrl + "/common/groups/with/head/planfix";
  public getGeneralNotification = this.baseApiUrl + "/common/notifications/general_natification/"; 
  public getSuggestionNotificationsHistory = this.baseApiUrl + "/common/notifications/suggestions";
  public getGeneralNotificationsHistory = this.baseApiUrl + "/common/notifications/general";
  public getDepartmentGroups = this.baseApiUrl + "/common/groups/department";
  public getAffiliateGroups = this.baseApiUrl + "/common/groups/affiliate";
  public getGlobalGroups = this.baseApiUrl + "/common/groups/global";
  public getGroupById = this.baseApiUrl + "/common/group/"; // +ID
  public deleteEvent = this.baseApiUrl + "/common/head/user/schedule/event/"; // +ID
  public getTasks = this.baseApiUrl + "/common/tasks/";
  public getAllStandards = this.baseApiUrl + "/common/head/standards/";
  public getAllStandardsId = this.baseApiUrl + "/common/standard/headstandards/";
  public getAllStandardsWithoutSort =
    this.baseApiUrl + "/common/head/all/standards";
  public getAllPositions = this.baseApiUrl + "/common/positions";
  public getFileById = this.baseApiUrl + "/common/standard/file/";
  public getKarmaInfo = this.baseApiUrl + "/common/user/karma/"
  public getChtoto = this.baseApiUrl + "/common/user/";
  public getWorksDay = this.baseApiUrl + "/common/user/working_dey";
  public getStandard = this.baseApiUrl + "/common/standard/"; // {sID}
  public standardAiQuestions = this.baseApiUrl + "/common/standard/";
  public deleteStandard = this.baseApiUrl + "/common/standard/delete";
  public deleteUser = this.baseApiUrl + "/common/group/user/delete";
  public getTempStandard = this.baseApiUrl + "/common/standard/";
  public getMyReport = this.baseApiUrl + "/common/head/create/standard";
  public getUserReport = this.baseApiUrl + "/common/user/"; // +{u_id}/report
  public postVacation = this.baseApiUrl + "/common/user/vacation";
  public getRequestOnProlong = this.baseApiUrl + "/common/user/request_to_confirm_for_prolong_vacation";
  public getVacation = this.baseApiUrl + "/common/user/vacation/";
  public getUserReportOff = this.baseApiUrl + "/common/head/users/begOff/";
  public getGroupReportOff = this.baseApiUrl + '/common/head/group/';
  public getStandardsForUser = this.baseApiUrl + "/common/user/"; // + {u_id}/standards
  public getPrefixesForGroup = this.baseApiUrl + "/common/prefix/group/"; // +{g_id}
  public getCountStandardNum = this.baseApiUrl + "/common/prefix/daycount/"; // +{p_id}
  public getAllTypes = this.baseApiUrl + "/common/type/all";
  public getStandardsForGroupHead =
    this.baseApiUrl + "/common/standard/headstandards";
  public getStandardsByValueGroupHead =
    this.baseApiUrl + "/common/standard/headstandards";
  public getAllHeadingGroups = this.baseApiUrl + "/common/group/heading/all";
  public getGroupReport = this.baseApiUrl + "/common/head/group/"; // +{g_id}/report
  public getUsersOutsideOfGroup =
    this.baseApiUrl + "/common/head/usersoutside/"; // +{g_id}
  public getQuestionsForCurrentUser = this.baseApiUrl + "/common/test";
  public getQuestionsForCurrentUserStep = this.baseApiUrl + "/common/standard/";
  public getPdf = this.baseApiUrl + "/common/pdf/";
  public getBlanks = this.baseApiUrl + "/common/standard/blanks";
  public getAllSpecs = this.baseApiUrl + "/common/specgroup/all";
  public getSpecById = this.baseApiUrl + "/common/spec/get/";
  public getLearningSpecsById = this.baseApiUrl + "/common/specgroup/user/";
  public getLearningSpecsProfile =
    this.baseApiUrl + "/common/specgroup/user/profile/";
  public getLearningSpecsUser = this.baseApiUrl + "/common/spec/learn/";
  // Create
  public createSchedule = this.baseApiUrl + "/admin/schedule/";
  public createScheduleHead = this.baseApiUrl + "/common/head/schedule";
  public createPosition = this.baseApiUrl + "/common/head/group/"; // +ID/position
  public createPositionGlobal = this.baseApiUrl + "/common/positions";
  public createUser = this.baseApiUrl + "/admin/user/";
  public createGroup = this.baseApiUrl + "/admin/groups/";
  public addFileToStandard = this.baseApiUrl + "/common/head/standard/file/";
  public createStandard = this.baseApiUrl + "/admin/standard";
  public uploadFileTemp = this.baseApiUrl + "/common/standard/tmp/file";
  public uploadFile = this.baseApiUrl + "/common/standard/file";
  public uploadBlank = this.baseApiUrl + "/common/standard/blanks";
  public uploadBlankTemp = this.baseApiUrl + "/common/standard/tmp/blanks";
  public createPrefixForGroups = this.baseApiUrl + "/admin/prefix";
  public createSpecGroup = this.baseApiUrl + "/common/specgroup/create";
  public createSubSpecGroup = this.baseApiUrl + "/common/specgroup/create/";
  public createSpec = this.baseApiUrl + "/common/spec/create/";
  public setQualificationLevel = this.baseApiUrl + "/common/spec/set/";
  public uploadSpecFile = this.baseApiUrl + "/common/specialization/file/";
  // Old create type rout
  public createStandardType = this.baseApiUrl + "/common/type/";
  // New create type rout
  // public createStandardType = this.baseApiUrl + '/common/type/create';
  public createHeadStandard = this.baseApiUrl + "/common/head/standard";
  // public createHeadStandard = this.baseApiUrl + '/common/standard';
  // public updateHeadStandard = this.baseApiUrl + '/common/standard';
  public updateHeadStandard = this.baseApiUrl + "/common/head/standard";
  public goToDiscussion = this.baseApiUrl + "/common/standard/";
  public goToFamiliarization = this.baseApiUrl + "/common/standard/";
  public getConfirmatoriesInfo = this.baseApiUrl + "/common/standard/"; // + {s_id} + /confirmatories/info
  public checkAnswersForTesting = this.baseApiUrl + "/common/test/pass";
  // Put
  public putUserOfGroup = this.baseApiUrl + "/common/head/group/"; // {g_id}/adduser/{u_id}/{p_id}
  public getExcelReport = this.baseApiUrl + "/common/report/excel";
  public addQuestionToStandard = this.baseApiUrl + "/admin/standard/question";
  public editQuestionInStandard =
    this.baseApiUrl + "/admin/standard/question/edit";
  public editPrefixForGroups = this.baseApiUrl + "/admin/prefix";
  public editStandardType = this.baseApiUrl + "/common/type";
  public checkUserAnswers = this.baseApiUrl + "/common/spec/test/";
  // Patch
  public updateSpec = this.baseApiUrl + "/common/spec/update";
  public setHeadsForGroup = this.baseApiUrl + "/common/head/group/"; // {g_id}/setheads/{h_id}/{d_id}
  public changeUserStatusInGroup = this.baseApiUrl + "/common/head/group/"; // {g_id}/{u_id}/status
  public updateUser = this.baseApiUrl + "/common/head/user/"; // body User
  // public updateGroup = this.baseApiUrl + '/common/head/group/'; OLD
  public updateGroup = this.baseApiUrl + "/common/groups/";
  public changeKarmaUser = this.baseApiUrl + '/common/head/user/karma';
  public changeVector = this.baseApiUrl + "/common/head/users/vector/"
  public convertGroup = this.baseApiUrl + "/common/groups/convert/";
  public addRelative = this.baseApiUrl + "/common/groups/add/relative";
  public addQuestionToStandardById =
    this.baseApiUrl + "/admin/standard/questions/";
  public markNotify = this.baseApiUrl + "/common/notifications/";
  public markNotifyNot = this.baseApiUrl + "/common/notifications/confirmed";
  public updateSpecGroup = this.baseApiUrl + "/common/specgroup/update/";
  public disseminateStandard =
    this.baseApiUrl + "/common/head/standard/distribute";
  public disseminateStandardNew = this.baseApiUrl + "/common/head/standard/";
  // head/standard/{sid}/distribute
  public deleteQuestion = this.baseApiUrl + "/admin/standard/question";
  public changeStandardStatus = this.baseApiUrl + "/admin/standard/status";
  public changeStandardStatusHead = this.baseApiUrl + "/admin/standard/status";
  public changeInitiator = this.baseApiUrl + "/admin/standard/initiator";
  public changeDivision = this.baseApiUrl + "/common/standard/"; // {s_id}/group/{g_id}
  // public changeDivision = this.baseApiUrl + '/admin/standard/';  // {s_id}/group/{g_id}
  public editStandardInfo = this.baseApiUrl + "/admin/standard/info";
  public changePositionStatus = this.baseApiUrl + "/common/positions/";
  // CHANGE USER'S POSITION
  public changeUserPositionInGroup = this.baseApiUrl + "/common/head/group/"; // {gid}/{uid}/position'
  // CHANGE USER PASSWORD
  public changeUserPassword = this.baseApiUrl + "/admin/user/pass";
  // CHANGE POSITION NAME
  public changePositionNameInGroup = this.baseApiUrl + "/common/head/position";
  // DELETE POSITION
  public deletePositionFromGroup = this.baseApiUrl + "/admin/position";
  // Delete
  public deleteBlankFromStandard = this.baseApiUrl + "/common/blank";
  public deleteBlankFromStandardTemp =
    this.baseApiUrl + "/common/standard/tmp/blank";
  public deleteFileFromStandard = this.baseApiUrl + "/common/standard/file";
  public deleteFileFromStandardTemp =
    this.baseApiUrl + "/common/standard/tmp/file";
  // HttpClient
  public familiarizeWithStandard = this.baseApiUrl + "/common/standard/";
  public approvedStandard = this.baseApiUrl + "/common/standard/";
  public requiresModification = this.baseApiUrl + "/common/standard/";
  public sendPost = this.baseApiUrl + "/common/chat/";
  public readNotifications = this.baseApiUrl + "/common/notifications/";
  public doModifications = this.baseApiUrl + "/common/standard/modify";
  public getFamiliarizeInfo = this.baseApiUrl + "/common/standard/";
  public goToTesting = this.baseApiUrl + "/common/standard/";
  public checkAnswersForTestingStep = this.baseApiUrl + "/common/standard/";
  public getStandardOutsidesUsers = this.baseApiUrl + "/common/users/standard/";
  public addUserToStandard = this.baseApiUrl + "/common/standard/";
  public deleteUserFromStandard = this.baseApiUrl + "/common/standard/";
  public getSelf = this.baseApiUrl + "/common/user";
  public changePass = this.baseApiUrl + "/common/user/password_change";
  public patchTmpStandard = this.baseApiUrl + "/common/standard/";
  public publishStandardNoNotify = this.baseApiUrl + "/common/standard/";
  public publishStandardWithNotify = this.baseApiUrl + "/common/standard/";
  public changeStatusDeactivate = this.baseApiUrl + "/common/standard/";
  public getChangeLogs = this.baseApiUrl + "/common/standard/";
  public getExNotifications = this.baseApiUrl + "/common/notifications/expired";
  public getNearExNotification =
    this.baseApiUrl + "/common/notifications/expired/first";
  public setTempQuestionsForStandard = this.baseApiUrl + "/common/standard/";
  public getNotificationById = this.baseApiUrl + "/common/notifications/";
  public renamePosGlobal = this.baseApiUrl + "/common/positions";
  public changeSalaryValue = this.baseApiUrl + "/common/head/users/salary";
  public changeModalSetting = this.baseApiUrl + "/admin/setting";
  public legacyChangeModalSetting = this.baseApiUrl + "/setting";

  public getListWeekends = this.baseApiUrl + "/common/calendar/weekend_schedule";
  public addWeekends = this.baseApiUrl + "/common/calendar/weekend_schedule/create";
  public delWeekends = this.baseApiUrl + "/common/calendar/weekend_schedule/delete/";
  public calendarMarkers = this.baseApiUrl + "/common/calendar/markers";
  public calendarMarkerGroups = this.baseApiUrl + "/common/calendar/markers/groups";

  public getStandardTranslate = this.baseApiUrl + "/common/standard/";
  public getQuestionForTranslateByStandardID =
    this.baseApiUrl + "/common/standard/";
  public getStandardBaseLanguageByID =
    this.baseApiUrl + "/common/standard/language/";
  public translatedMainInfo = this.baseApiUrl + "/common/translation/standard/";
  public doneStandardMainInfo = this.baseApiUrl + "/common/standard/";
  public sendTranslateQuestionsRequest =
    this.baseApiUrl + "/common/translation/questions/";
  public addQuestionsToStandardHead =
    this.baseApiUrl + "/common/head/standard/";
  public doneTranslateQuestions = this.baseApiUrl + "/common/standard/";
  public getGroupsWithPos =
    this.baseApiUrl + "/common/group/all-with-positions";
    public getGroupsWithPosHead =
    this.baseApiUrl + "/common/group/head-with-positions";
  public getAllPrefixesFromAPI =
    this.baseApiUrl + "/common/prefix/get-all-prefixes";
  public getTypesByPrefixID = this.baseApiUrl + "/common/type/";
  public getTypesForGroup = this.baseApiUrl + "/common/type/";
  public readNotificationByCategoryAndID =
    this.baseApiUrl + "/common/notifications/read/";
  // SUGGESTIONS LISTS
  public addNewSL = this.baseApiUrl + "/common/suggestions/";
  public addNewMist = this.baseApiUrl + "/common/suggestions/error/";
  public addNewSLDeleteDraft = this.baseApiUrl + "/common/suggestions/"; // {slID}
  public checkLevel = this.baseApiUrl + "/common/spec/learn/task/";
  public pushTask = this.baseApiUrl + "/common/spec/learn/task/";  // {slID}
  public addNewDraft = this.baseApiUrl + "/common/suggestions/draft";
  public updateDraft = this.baseApiUrl + "/common/suggestions/draft";
  public getDraftsByUserID = this.baseApiUrl + "/common/suggestions/user/";
  public getSLByUserID = this.baseApiUrl + "/common/suggestions/user/";
  public getSLByID = this.baseApiUrl + "/common/suggestions/";
  public getAllSLForUser = this.baseApiUrl + "/common/suggestions/group/";
  public redirectSL = this.baseApiUrl + "/common/suggestions/";
  public cancelSL = this.baseApiUrl + "/common/suggestions/";
  public postponeSL = this.baseApiUrl + "/common/suggestions/";
  public implementSL = this.baseApiUrl + "/common/suggestions/";
  public addMessageToSLChat = this.baseApiUrl + "/common/suggestions/chat/";
  public addTasksToPlanfix =
    this.baseApiUrl + "/common/suggestions/assignTasks";
  public getAllSLForReviewForHead =
    this.baseApiUrl + "/common/suggestions/review/";
  public getSLChatHistory = this.baseApiUrl + "/common/suggestions/chat/";
  public getSLPhotos = this.baseApiUrl + "/common/suggestions/";
  public uploadSLPhotos = this.baseApiUrl + "/common/suggestions/photos/";
  public getTempFileLink = this.baseApiUrl + "/common/files";
  public deleteTempFileLink = this.baseApiUrl + "/common/files";
  public deleteTempDocxFileManually = this.baseApiUrl + "/common/files/byLink";
  public deleteTempDocxFileManuallyTemp =
    this.baseApiUrl + "/common/standard/tmp/file/byLink";
  // STANDARDS MANAGEMENT
  public searchStandardsWithName =
    this.baseApiUrl + "/common/head/standards/search";
  public searchManagementStandardsWithUser =
    this.baseApiUrl + "/common/head/standards/searchWithUser";
  public searchStandardsWithoutUserOnPosition =
    this.baseApiUrl + "/common/head/standards/searchWithoutUserOnPosition";
  public searchPersonalStandards =
    this.baseApiUrl + "/common/head/standards/searchPersonal";
  public searchManagementUser = this.baseApiUrl + "/common/users/search";
  public searchManagementPositions =
    this.baseApiUrl + "/common/positions/search";
  public searchManagementGroup = this.baseApiUrl + "/common/group/search";
  public removeUsersFromStd =
    this.baseApiUrl + "/common/head/standards/removeUsers";
  public assignStandards =
    this.baseApiUrl + "/common/head/standards/distribute";
  public employeeStandardOverrides =
    this.baseApiUrl + "/common/head/groups/";
  public morningOvertimeReadinessState =
    this.baseApiUrl + "/common/morning-overtime-readiness/state";
  public morningOvertimeReadinessAnswers =
    this.baseApiUrl + "/common/morning-overtime-readiness/answers";
  public morningOvertimeHeadGroupSettings =
    this.baseApiUrl + "/common/head/groups/";

  // Standard number management
  public checkStandardNumberUniqueness =
    this.baseApiUrl + "/common/standard/check-number";
  public updateStandardNumber =
    this.baseApiUrl + "/common/standard/update-number";

  // usersModule
  public getUsers = this.baseApiUrl + "/admin/user/management/show";
  public getGroups = this.baseApiUrl + "/admin/groups";
  public getGroupsWithDepartmentMarker =
    this.baseApiUrl + "/admin/groups/with-department-marker";
  public updateGroupDepartmentMarker =
    this.baseApiUrl + "/admin/groups/";
  public getUserInfo = this.baseApiUrl + "/admin/user/management/";
  public getPositions = this.baseApiUrl + "/common/positions?active=true";

  // Vacations
  public getUserVacations = this.baseApiUrl + "/common/user/"; // + {userId}/vacations

  constructor() {

  }

  getPlanfixTaskUrl(taskId: number): string {
    return `${this.planfixBaseUrl}/?action=planfix&task=${taskId}`;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/api-connect.service.ts